import { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select'
import { optionCSS } from 'react-select/dist/declarations/src/components/Option';
import TranslationContext from '../../providers/TranslationContext';
import ValidationContext from '../../providers/ValidationContext';
import { validateField } from '../../validation/formValidation';

interface Props {
    label?: string;
    placeholder: string;
    id?: string;
    dataField: string;
    displayField?: string;
    formData?: any;
    setStateMethod?: any;
    value?: any;
    options: any;
    isDisabled: boolean;
    isMulti?: boolean;
    hideSelectedOptions?: boolean;
    customLeftCols?: any; // for example col-sm-3
    customRightCols?: any; // for example col-sm-9
    isRequired?: boolean;
    className?: string;
    handleOnChange?: any;
    ignoreP3Margin?: boolean;
}

require("./SelectBox.css");

export const SelectBox = (props: Props) => {
    const crypto = require("crypto");

    const { t } = useTranslation();
    const popupModel = useContext(TranslationContext) as any;
    const prefix = popupModel.prefix;

    const [validationModel, setValidationModel] = useState<any>();
    const [isValid, setIsValid] = useState(true);
    const [isRequired, setIsRequired] = useState(false);
    const [selectedValue, setSelectedValue] = useState<undefined | Array<object>>(undefined);
    let leftColumnClass = `${props.customLeftCols ?? "col-sm-3"
        } col-form-label zvlabel`;

    let rightColumnClass = `${props.customRightCols ?? "col-sm-9"}`;

    const formValidationModel = useContext(ValidationContext) as any;
    const fieldValidationModel = formValidationModel?.fields?.[props.dataField];

    const hideSelectedOptions = typeof props.hideSelectedOptions == "boolean" ? props.hideSelectedOptions : true;

    const className = props.className ?? 'select-box';


    useEffect(() => {
        if (fieldValidationModel) {
            setIsValid(fieldValidationModel?.isValid !== undefined ? fieldValidationModel.isValid : true);
            setValidationModel(fieldValidationModel);
        }
    }, [fieldValidationModel?.isValid]);

    useEffect(() => {
        const fieldValidationModel = formValidationModel?.fields?.[props.dataField];
        if (fieldValidationModel) {
            setValidationModel(fieldValidationModel);
            setIsRequired(props.isRequired ?? fieldValidationModel?.isRequired);
        }
    }, []);

    useEffect(() => {
        let tempSelectedValue: undefined | Array<object> = undefined;
        if (props.value) {
            if (!props.isMulti) {
                if (props.options) {
                    tempSelectedValue = props.options.find((o: any) => { return o.value == props.value });
                }
            }
            else {
                if (props.options && props.options.length > 0) {
                    tempSelectedValue = props.value.map((m: any) => {
                        const match = props.options.find((o: any) => { return o.value === m.value });
                        return { ...match, uniqueId: m.uniqueId }
                    });
                }
            }
            setSelectedValue(tempSelectedValue);
        }
    }, [props.value, props.options]);

    let label = props.label;
    let placeholder = props.placeholder;
    if (prefix) {
        label = t(`${prefix}.Fields.${props.dataField}`);
        placeholder = `${t(`${prefix}.Fields.${props.dataField}`)}...`;
    }

    return (
        <>
            {props.label ?
                <div className={isValid ? "row" : "row invalid"}>
                    <label htmlFor={props.id} className={leftColumnClass}>
                        {label}{isRequired && <span className="required">*</span>}
                    </label>
                    <div className={rightColumnClass}>
                        <Select
                            className={className}
                            classNamePrefix={className}
                            isSearchable={true}
                            isMulti={props.isMulti}
                            options={props.options}
                            value={selectedValue}
                            placeholder={placeholder}
                            isDisabled={props.isDisabled}
                            hideSelectedOptions={hideSelectedOptions && props.isMulti}
                            onChange={(event: any, option: any) => {
                   
                                if (props.handleOnChange) {
                                    props.handleOnChange(props.formData[props.dataField]);
                                }

                                if (!hideSelectedOptions) {
                                    if (option.action === 'clear') {
                                        props.formData[props.dataField] = [];
                                        props.setStateMethod({ ...props.formData });
                                    }
                                    if (option.action === 'select-option' || option.action === 'deselect-option') {
                                        const id = crypto.randomBytes(16).toString("hex");
                                        var addedOption = { ...option.option, uniqueId: `${option.option.id}_${id}` };
                                        const tempSelectedValue = (!selectedValue || selectedValue == undefined) ?
                                            [] : selectedValue;
                                        if (tempSelectedValue) {
                                            tempSelectedValue.push(addedOption);
                                        }
                                        setSelectedValue(tempSelectedValue);

                                        props.formData[props.dataField] = tempSelectedValue;
                                        props.setStateMethod({ ...props.formData });
                                    }
                                    if (option.action === 'remove-value') {
                                        const uniqueId = option.removedValue.uniqueId;
                                        const tempSelectedValue = selectedValue;
                                        if (tempSelectedValue) {
                                            let index = tempSelectedValue.findIndex(e => { return e['uniqueId'] === uniqueId });
                                            if (index > -1) {
                                                tempSelectedValue.splice(index, 1);
                                            }
                                            setSelectedValue(tempSelectedValue);

                                            props.formData[props.dataField] = tempSelectedValue;
                                            props.setStateMethod({ ...props.formData });
                                        }
                                    }
                                }
                                else {
                                    var value = !Array.isArray(event) ? event.value : event;
                                    validateField(value, validationModel);
                                    if (props.formData) {
                                        props.formData[props.dataField] = value;
                                        if (props.displayField && !Array.isArray(event)) {
                                            props.formData[props.displayField] = event.label;
                                        }
                                        if (props.setStateMethod) {
                                            props.setStateMethod({ ...props.formData });
                                        }
                                    }
                                    else {
                                        props.setStateMethod(value);
                                    }
                                }
                            }}
                        />
                        {validationModel?.errors &&
                            <span className="validation-errors">
                                {validationModel?.errors.map(e => {
                                    return e;
                                })}
                            </span>
                        }
                    </div>
                </div>
                :
                <div className={`${props.ignoreP3Margin ? '' : 'p-3'}`}>
                    <Select
                        isSearchable={true}
                        isMulti={false}
                        className={props.className}
                        options={props.options}
                        value={selectedValue}
                        placeholder={props.placeholder}
                        isDisabled={props.isDisabled}
                        onChange={(event: any) => {
                            if (props.handleOnChange) {
                                props.handleOnChange(props.formData[props.dataField]);
                            }

                            if (props.formData) {
                                props.formData[props.dataField] = event.value;
                                if (props.displayField) {
                                    props.formData[props.displayField] = event.label;
                                }
                                if (props.setStateMethod) {
                                    props.setStateMethod({ ...props.formData });
                                }


                            }
                            else {
                                props.setStateMethod(event.value);
                            }
                        }}
                    />
                </div>
            }
        </>
    );
};